import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './StaticTitle.css';

const StaticTitle = ({ title }) => (
  <div className={styles.container}>
    <h2 className={styles.title}>{title}</h2>
  </div>
);

StaticTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default StaticTitle;



// WEBPACK FOOTER //
// ./src/components/StaticPages/StaticTitle.jsx